export default __webpack_public_path__ + "static/media/img (2).95d47028.jpg";